// PHOENIX-959: credencial de parametro (senha, token, chave privada) chega do back como MASCARA_CREDENCIAL,
// nunca com o valor real. Regras de edicao usadas pelas telas de parametros da empresa e da unidade.

export const MASCARA_CREDENCIAL = '********'

export const ACAO_SALVAR = {
  // Credencial nao alterada: nada a enviar, o back mantem o valor gravado.
  MANTER: 'MANTER',
  // Nome da chave mudou sem valor novo: o valor real nao esta no navegador para ir junto.
  RENOMEAR_SEM_VALOR: 'RENOMEAR_SEM_VALOR',
  GRAVAR: 'GRAVAR',
}

// Ao abrir para edicao: credencial mascarada abre com o campo vazio, para ninguem editar a mascara como se fosse o
// valor (o back recusa a mascara alterada).
export const prepararEdicao = (registro) => {
  const credencialMascarada = registro.value === MASCARA_CREDENCIAL
  return {
    parametro: Object.assign({}, registro, credencialMascarada ? { value: '' } : {}),
    credencialMascarada,
  }
}

// Nome alterado no campo: Remover ficaria ambiguo (apagaria a chave original, nao a digitada).
export const isNomeAlterado = ({ parametro, parametroAnterior, novoParametro }) =>
  !novoParametro && !!parametro && !!parametroAnterior && parametro.id !== parametroAnterior.id

// Remover apaga a chave SELECIONADA na grade. No dialogo de Novo (a selecao pode ser de antes) ou com o nome alterado,
// apagaria uma chave diferente da que esta na tela.
export const podeRemover = (estado) =>
  !estado.novoParametro && !!estado.parametroSelecionado && !!estado.parametroSelecionado.id && !isNomeAlterado(estado)

const nomeLimpo = (id) => (id || '').trim()

export const isNomeVazio = (parametro) => !parametro || nomeLimpo(parametro.id) === ''

// Nome que vai ao back: novo ou alterado vai sem espaco nas pontas (chave com espaco no fim nao e achada pela busca
// exata do sistema). Chave existente com o nome intocado vai como esta - aparar ali seria renomear sem o usuario pedir.
export const comNomeParaGravar = (parametro, parametroAnterior, novoParametro) => {
  if (!novoParametro && parametroAnterior && parametro.id === parametroAnterior.id) {
    return parametro
  }
  return Object.assign({}, parametro, { id: nomeLimpo(parametro.id) })
}

// Novo, ou renomear, para um nome que ja existe sobrescreveria aquela chave sem aviso - e, mascarada, ninguem ve que
// havia uma credencial ali (no renomear, a original ainda seria apagada em seguida).
// Recebe o parametro ja com o nome de gravar (comNomeParaGravar). A propria chave em edicao fica de fora pelo nome
// exato: renomear "tokenAutentique " para "tokenAutentique" passa, mas nao se as duas existirem.
export const isNomeEmUso = (registros, parametro, parametroAnterior, novoParametro) => {
  const nome = nomeLimpo(parametro && parametro.id)
  const original = !novoParametro && parametroAnterior ? parametroAnterior.id : undefined
  if (original !== undefined && parametro.id === original) {
    return false
  }
  return (registros || []).some((r) => r && r.id !== original && nomeLimpo(r.id) === nome)
}

// Erro do back para showMessages (que espera lista): a recusa vem como texto, as vezes como lista. Sem resposta util
// (rede, timeout, pagina do balanceador, corpo vazio), o erro do axios vem em ingles e nao diz se gravou - vai o texto
// do dicionario recebido.
export const mensagensDeErro = (err, textoSemResposta) => {
  const data = err && err.response ? err.response.data : undefined
  if (Array.isArray(data) && data.length > 0) {
    return data
  }
  // A recusa do back vem como texto. Pagina HTML (502/504 do balanceador) ou corpo vazio nao diz nada ao usuario - e
  // e justamente o caso em que a gravacao pode ter acontecido ou nao.
  if (typeof data === 'string' && data.trim() !== '' && !data.trim().startsWith('<')) {
    return [data]
  }
  return [textoSemResposta]
}

export const acaoAoSalvar = (parametro, parametroAnterior, credencialMascarada) => {
  const semValorNovo = !parametro.value || parametro.value.trim() === ''
  const renomeado = parametro.id !== parametroAnterior.id
  if (credencialMascarada && semValorNovo) {
    return renomeado ? ACAO_SALVAR.RENOMEAR_SEM_VALOR : ACAO_SALVAR.MANTER
  }
  // Mascara digitada com nome novo (qualquer chave): o back le como "manter o valor da chave NOVA" e responde ok sem
  // gravar, e a tela apagaria a chave antiga em seguida - perdendo o valor dela.
  if (renomeado && parametro.value && parametro.value.trim() === MASCARA_CREDENCIAL) {
    return ACAO_SALVAR.RENOMEAR_SEM_VALOR
  }
  return ACAO_SALVAR.GRAVAR
}
